import { AuthorizationRoutes } from './views/authorization/authorization.routes';
import { OAuthRoutes } from './views/oauth/oauth.routes.ts';
import { PrivateRoutes } from './views/private/private.routes';
import { PublicRoutes } from './views/public/public.routes';
export default [...AuthorizationRoutes, ...OAuthRoutes, ...PrivateRoutes, ...PublicRoutes];
